import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const ProductActivity = () => {
  const [selectedPeriod, setSelectedPeriod] = useState('monthly');
  const [isAnimating, setIsAnimating] = useState(false);
  const [chartLabels, setChartLabels] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProductActivity = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/api/dashboard/product-activity?period=${selectedPeriod}`);
        const result = response.data;
        console.log('Product Activity API Response:', result);
        if (result && result.success && result.data) {
          const labels = result.data.labels || [];
          const data = result.data.data || [];
          // Ensure minimum 3 data points for better chart appearance
          const minDataPoints = 3;
          if (labels.length < minDataPoints && labels.length > 0) {
            const paddedLabels = [...labels];
            const paddedData = [...data];
            while (paddedLabels.length < minDataPoints) {
              paddedLabels.push('');
              paddedData.push(0);
            }
            setChartLabels(paddedLabels);
            setChartData(paddedData);
          } else {
            setChartLabels(labels);
            setChartData(data);
          }
        } else {
          setChartLabels([]);
          setChartData([]);
        }
      } catch (error) {
        console.error('Failed to fetch product activity:', error);
        setChartLabels([]);
        setChartData([]);
      } finally {
        setLoading(false);
      }
    };
    fetchProductActivity();
  }, [selectedPeriod]);

  const handleFilterChange = (period) => {
    setIsAnimating(true);
    setSelectedPeriod(period);
    setTimeout(() => setIsAnimating(false), 500);
  };

  const maxValue = Math.max(...chartData, 1);

  const getBarConfig = () => {
    if (chartData.length === 1) {
      return {
        maxWidth: '80px',
        justifyContent: 'center',
        gap: '0'
      };
    }
    if (chartData.length <= 5) {
      return {
        maxWidth: '120px',
        justifyContent: 'center',
        gap: '20px'
      };
    }
    return {
      maxWidth: 'none',
      justifyContent: 'space-between',
      gap: '0'
    };
  };

  const barConfig = getBarConfig();

  if (loading) {
    return (
      <div className="dashboard-card activity-card">
        <div className="card-body">
          <div className="card-header">
            <h3 className="card-title">Product Upload Activity</h3>
            <div className="filter-buttons">
              {['daily', 'weekly', 'monthly'].map(filter => (
                <button
                  key={filter}
                  className={`filter-btn ${selectedPeriod === filter ? 'active' : ''}`}
                  onClick={() => handleFilterChange(filter)}
                >
                  {filter.charAt(0).toUpperCase() + filter.slice(1)}
                </button>
              ))}
            </div>
          </div>
          <div className="chart-container activity-chart">
            <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
              Loading...
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (chartData.length === 0) {
    return (
      <div className="dashboard-card activity-card">
        <div className="card-body">
          <div className="card-header">
            <h3 className="card-title">Product Upload Activity</h3>
            <div className="filter-buttons">
              {['daily', 'weekly', 'monthly'].map(filter => (
                <button
                  key={filter}
                  className={`filter-btn ${selectedPeriod === filter ? 'active' : ''}`}
                  onClick={() => handleFilterChange(filter)}
                >
                  {filter.charAt(0).toUpperCase() + filter.slice(1)}
                </button>
              ))}
            </div>
          </div>
          <div className="chart-container activity-chart">
            <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
              No data available
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-card activity-card">
      <div className="card-body">
        <div className="card-header">
          <h3 className="card-title">Product Upload Activity</h3>
          <div className="filter-buttons">
            {['daily', 'weekly', 'monthly'].map(filter => (
              <button
                key={filter}
                className={`filter-btn ${selectedPeriod === filter ? 'active' : ''}`}
                onClick={() => handleFilterChange(filter)}
              >
                {filter.charAt(0).toUpperCase() + filter.slice(1)}
              </button>
            ))}
          </div>
        </div>

        <div className={`chart-container activity-chart ${isAnimating ? 'animating' : ''}`}>
          <div className="chart-area" style={{
            display: 'flex',
            justifyContent: barConfig.justifyContent,
            gap: barConfig.gap
          }}>
            {chartData.map((value, index) => (
              <div
                key={`${selectedPeriod}-${index}`}
                className="bar-container"
                style={{
                  maxWidth: barConfig.maxWidth,
                  flex: barConfig.maxWidth === 'none' ? '1' : 'none'
                }}
              >
                <div
                  className="activity-bar"
                  style={{
                    height: `${(value / maxValue) * 100}%`,
                    animationDelay: `${index * 0.1}s`
                  }}
                  data-value={value}
                >
                  <div className="bar-tooltip">{value}</div>
                </div>
                <div className="bar-label">{chartLabels[index] || ''}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductActivity;